import { graphql } from "../gql";

export const getAgentTypesQueryDoc = graphql(`
  query getAgentTypes {
    agentTypes {
      key
      label
    }
  }
`);
